/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteReplyInfo,
    JsonInviteReplyInfoFromJSON,
    JsonInviteReplyInfoFromJSONTyped,
    JsonInviteReplyInfoToJSON,
} from './JsonInviteReplyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonInviteReplyInfo
 */
export interface ApiResultOfListOfJsonInviteReplyInfo {
    /**
     * 
     * @type {Array<JsonInviteReplyInfo>}
     * @memberof ApiResultOfListOfJsonInviteReplyInfo
     */
    data?: Array<JsonInviteReplyInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteReplyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonInviteReplyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteReplyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteReplyInfo
     */
    result?: ApiResultOfListOfJsonInviteReplyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonInviteReplyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonInviteReplyInfoFromJSON(json: any): ApiResultOfListOfJsonInviteReplyInfo {
    return ApiResultOfListOfJsonInviteReplyInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonInviteReplyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonInviteReplyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonInviteReplyInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonInviteReplyInfoToJSON(value?: ApiResultOfListOfJsonInviteReplyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonInviteReplyInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

